/**
 * 발주화면 렌더링
 *
 * Baljoo 클래스에서 print 패밀리(화면 그리기)를 담당하는 헬퍼.
 * Baljoo 인스턴스를 생성자에 받아 this.b 로 보관, 부모 상태에 접근한다.
 */
import Util from '../../Common/Util';

export default class Render {
    constructor(baljoo) {
        this.b = baljoo;
    }

    showJijungButton(flag = true) {
        if (flag) {
            $('.if-jijung').show();
            $('.if-not-jijung').hide();
        } else {
            $('.if-not-jijung').show();
            $('.if-jijung').hide();
        }
    }

    findPlaceName(msg, place) {
        if (msg.indexOf(place) === 0) {
            msg = msg;
        } else {
            if (msg) {
                msg = place + '\n' + msg;
            } else {
                msg = place;
            }
        }
        return msg;
    }

    openMap() {
        $j.Ui.BS.close();
        $j.F.KakaoMap.open(ORDER['mem_basepoint'], '1', $('#input_address').data('value'));
    }

    /**
     * 결제책임, 수수료여부 영역 보이기 / 숨기기
     * 슬라이드에서 결제책임 스킵하도록 하기
     */
    updateHowtopayUI() {
        const $el = $('#input_howtopay_title').parent();

        // 관리자 수정모드냐
        let isAdminModifyMode = (editMode == 'myorderedit' && G5['isAdmin']);

        // 수발주자가 아니거나 장비불러 소속이 아니면 수수료율, 결제책임을 변경할수 없다.
        if ((MEMBER['mem_driver_type'] == '업체발주자' || !Util.isSosokJbbuller(ORDER['order_sosok'])) && !isAdminModifyMode) {
            this.b.stepSkip = ['howtopay'];
            $el.hide();
        } else {
            this.b.stepSkip = [];
            $el.show();
        }
    }

    /**
     * 모달에서 선택한 값을 해당컬럼에 출력한다.
     * @param id 슬라이드명
     * @param isFirst 페이지 초기화시점 여부
     */
    print(id, isFirst = false) {
        let tpl = '';
        let html = '';
        let data = {};
        let val;
        switch (id) {
            // 소속본사
            case 'sosok':
                this.printSosok(isFirst);
                break;
            // 장비종류
            case 'car':
                val = ORDER['car_type'];
                let en = $j.F.Car.engName(val);

                // 장비 이미지 변경
                const classList = $('#input_car_img').attr('class').split(' ');// 클래스 목록 가져오기
                const endingWithCarSelect = $.grep(classList, function (className) {
                    return className.endsWith('-select');// 특정 패턴으로 끝나는 클래스 추출
                });
                endingWithCarSelect.forEach((v) => {
                    $('#input_car_img').removeClass(v);
                });
                $('#input_car_img').addClass(en + '-select');

                // 장비명 변경
                $('#input_car_txt').html(val);
                break;
            // 장비대금
            case 'price':
                let p = ORDER['car_price'];
                if (!Util.isSosokJbbuller(ORDER['order_sosok']) && ORDER['car_price_bonsa']) p = ORDER['car_price_bonsa'];
                $('#input_price').val(Util.formatNumber(p));
                break;
            // 수수료
            case 'fee':
                if (ORDER['is_fee'] == 1) {
                    $('#input_fee').addClass('on');
                } else {
                    $('#input_fee').removeClass('on');
                }
                break;
            // 긴급
            case 'quick':
                $('#input_quick').removeClass('on');
                if (ORDER['is_quick']) $('#input_quick').addClass('on');
                break;
            // 작업일
            case 'workday':
                val = ORDER['work_day'];
                data = {
                    'm':    dayjs(val).format('MM'),
                    'd':    dayjs(val).format('DD'),
                    'yoil': Util.getYoil(val, true)
                };
                html = `<span class="fw_medium">${data.m}</span><span class="fw_regular fz_13 ml-05">월</span>&nbsp;<span class="fw_medium">${data.d}</span><span class="fw_regular fz_13 ml-05">일</span>&nbsp;<span class="fw_medium">(${data.yoil})</span>`;
                $('#input_workday').html(html);
                break;
            // 작업시간
            case 'worktime':
                val = ORDER['work_time'];
                data = {
                    'h': dayjs(val).format('HH'),
                    'i': dayjs(val).format('mm'),
                };
                html = `&nbsp;<span class="fw_medium">${data.h}</span><span class="fw_regular fz_13 ml-05">시</span>&nbsp;<span class="fw_medium">${data.i}</span><span class="fw_regular fz_13 ml-05">분</span>`;
                $('#input_worktime').html(html);
                break;
            // 결제책임
            case 'howtopay':
                if (ORDER['howtopay'] == 0) return;
                data = {
                    'm': G5['HOW_TO_PAY'][Util.int(ORDER['howtopay'])],
                    'n': G5['SIGN_DUE'][ORDER['sign_howlong_int']]
                };
                html = `<span>${data.m}</span>&nbsp;`;
                if (ORDER['howtopay'] == 1) {
                    html += `<span class="fw_11">(${data.n})</span>`;
                }
                $('#input_howtopay').html(html);

                break;
            // 소요시간
            case 'howlong':
                if (ORDER['car_workhour'] == 0) return;
                html = `<span >${$j.F.Car.getWorkHourStr(ORDER)}</span>&nbsp;`;
                $('#input_howlong').html(html);

                break;
            // 기종옵션
            case 'option':
                if (ORDER['car_range']) {
                    html = $j.F.Car.getCarRangeStr(ORDER, 1) + ' ' + $j.F.Car.getCarOptionStr(ORDER);
                    if (html.trim()) {
                        $('#input_option').html(html);
                    }
                } else {
                    $('#input_option').html('<span class="place-holder">기종옵션</span>');
                }
                break;
            // 현장주소
            case 'map':
                $('#input_address').text(Util.nvl(ORDER['contract_address'])).data('value', ORDER['contract_address']);
                // 상세주소는 전달사항에 표시
                let msg = $('#input_contract_message').val();
                msg = this.findPlaceName(msg, ORDER['place_name']);
                $('#input_contract_message').val(msg);
                break;
            case 'contract_message':
                $('#input_contract_message').val(ORDER['contract_message']);
                break;
            case 'contract_name':
                $('#input_contract_name').val(ORDER['contract_name']);
                break;
            case 'contract_number':
                $('#input_contract_number').val(Util.phoneNumber(ORDER['contract_number']));
                break;
            case 'contract_fieldnumber':
                $('#input_contract_fieldnumber').val(Util.phoneNumber(ORDER['contract_fieldnumber']));
                break;
            case 'meta':
                this.b.strategy && this.b.strategy.bindMeta(ORDER);
                break;
            case 'jijung':
                if (ORDER.$r['order_type']) {
                    $('.assign-extra').hide();
                    $('#input_jijung_area').show();
                    switch (ORDER.$r['order_type']) {
                        case '91':// 임의
                            $('#input_jijung_area .jijung_title').html('소속기사');
                            $('#input_jijung_area .jijung_num').text(Util.nvl(ORDER.$r['worker_carplate']));
                            $('#input_jijung_area .jijung_name').text(Util.nvl(ORDER.$r['worker_name']));
                            break;
                        case '94':// 외부
                            $('#input_jijung_area .jijung_title').html('비회원');
                            $('#input_jijung_area .jijung_num').text(Util.nvl(ORDER.$r['hp']));
                            $('#input_jijung_area .jijung_name').text(Util.nvl(ORDER.$r['hp_name']));
                            break;
                        case '95':// 지정
                            $('#input_jijung_area .jijung_title').html('회원');
                            $('#input_jijung_area .jijung_num').text(Util.nvl(ORDER.$r['hp']));
                            $('#input_jijung_area .jijung_name').text(Util.nvl(ORDER.$r['hp_name']));
                            break;
                    }
                } else {
                    $('#input_jijung_area').hide();
                    $('.assign-extra').show();
                }
                break;
            case 'bonsa_col':
                // 본사별 부가정보 1칸 — 삼성,경원만 표시 (저장은 meta(JSON))
                switch (ORDER['order_sosok'].substring(0, 3)) {
                    case '019': // 삼성
                        $('#bonsa_col').parent().show();
                        $('#bonsa_col-title').html('수임<br>번호');
                        break;
                    case '021': // 경원
                        $('#bonsa_col').parent().show();
                        $('#bonsa_col-title').html('현장명');
                        break;
                    default:
                        $('#bonsa_col').parent().hide();
                }
                $('#bonsa_col').val(ORDER['bonsa_col']);
        }
    }

    /**
     * 소속을 그려준다.
     */
    printSosok(isFirst) {
        let html = '';
        // 최초에는 소속목록을 그려준다.
        const sosokList = sosoks;// 회원의 추가소속
        const list = [MEMBER['sosok'], ...sosokList];
        if (isFirst) {
            list.forEach((v) => {
                if (!v) return;
                const bonsacode = v.substring(0, 3);
                const gisacode = v.substring(0, 6);
                const centercode = v.substring(0, 9);

                if (!centerList[centercode]) {
                    const name = bonsaList[bonsacode] + ' > ' + gisaList[gisacode];
                    html += `<li class="item" data-value="${v}">${name}</li>`;
                } else {
                    const name = bonsaList[bonsacode] + ' > ' + centerList[centercode]
                    html += `<li class="item" data-value="${v}">${name}</li>`;
                }
            });
            $('#input_sosok_list').html(html);
            if (list.length > 1) $('#input_sosok_area .bracket_bottom').addClass('on');// 다중소속이면 선택할수있는 버튼 표시
        }

        // 소속 선택
        let code = MEMBER['sosok']; // 선택된 소속
        if (ORDER['order_sosok'] && list.includes(ORDER['order_sosok'])) {
            code = ORDER['order_sosok'];
        }
        ORDER['order_sosok'] = code;// 오더복사시에 소속이 변경될수있다. ( 수주자의 소속으로 변경되겄지 )

        const bonsacode = code.substring(0, 3);
        const gisacode = code.substring(0, 6);
        const centercode = code.substring(0, 9);

        if (!centerList[centercode]) {
            const name = bonsaList[bonsacode] + ' > ' + gisaList[gisacode];
            $('#input_sosok').html(name);
        } else {
            const name = bonsaList[bonsacode] + ' > ' + centerList[centercode]
            $('#input_sosok').html(name);
        }
    }
}
